
import React, { Fragment, useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate , useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { getDate, getItemFromStorage, setItemToStorage, userPicUrl } from "../../utils/Helper";
import { decodeID  , getLastURL } from "../../utils/Helper";
import { ContactDetailsGetAction } from "../../Redux/Action/ContactAction";



function Contactdetails() {
    const dispatch = useDispatch<any>();
    const navigate = useNavigate()
    const log_in = useSelector((state: any) => state.AdminLogInState)
    const contact_us_details = useSelector((state: any) => state.ContactDetailsState?.data?.data?.detail)
    const location = useLocation();
    const editId = getLastURL(location);
     const [loading  , setLoading] = useState(false)


    const handleBack = () => {
        navigate('/contact-us')
    }
    useEffect(()=>{
        setLoading(true)
        var params = {
            detail_id: decodeID(editId)
        };
     dispatch(ContactDetailsGetAction(params))
     setTimeout(() => {
        setLoading(false)
     }, 400);
    },[])
    return (
        <Fragment>
            { loading || log_in?.loading ? <Spinner /> : ""}
            <PageLayout
                title="User Support Management"
                breadcrumbs={{
                    secLast: { 'link': '/contact-us', 'name': 'User Support Management' },
                }}
                buttons={[
                    { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
                ]}
            >


                <div className="card">
                    <div className="card-body">
                        <div className="row gy-4">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Customer ID:</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.id ? contact_us_details?.id : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Name</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.name ? contact_us_details?.name : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Mobile</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details ? `${contact_us_details?.phone_country_code || '--'}  ${contact_us_details.phone_number || '--'}` : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Description</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.description ? contact_us_details?.description : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Email</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.email ? contact_us_details?.email : '--'}</span>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Status</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.is_reply == "1" ? "Replied" : "Not replied"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Date</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.created_at ? getDate(contact_us_details?.created_at) : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary waves-effect waves-light" onClick={() => handleBack()} >BACK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastDefault />
            </PageLayout>
        </Fragment>
    );
}

export default Contactdetails;




